// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3963":"css/admin-app.6803","5540":"css/app.6803"}[chunkId] + ".css";
};